// If you want to add new admin permissions, just add them here
export const PERMISSIONS = {
  SHOP: 'Shop',
};